import { useEffect } from "react";
import { SafeArea } from "@capacitor-community/safe-area";
import { Capacitor } from "@capacitor/core";

export function useSafeArea() {
  const isNativePlatform = Capacitor.isNativePlatform();
  const isAvailable = Capacitor.isPluginAvailable("SafeArea");

  useEffect(() => {
    if(isNativePlatform && isAvailable) {
        SafeArea.enable({config: {}});
    }
  }, []);
} 